import { useTheme } from 'styled-components';

export const QuestionIcon: React.FC = () => {
  const theme = useTheme();
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.1 14.4H9.9V12.6H8.1V14.4ZM9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM9 16.2C5.031 16.2 1.8 12.969 1.8 9C1.8 5.031 5.031 1.8 9 1.8C12.969 1.8 16.2 5.031 16.2 9C16.2 12.969 12.969 16.2 9 16.2ZM9 3.6C7.011 3.6 5.4 5.211 5.4 7.2H7.2C7.2 6.21 8.01 5.4 9 5.4C9.99 5.4 10.8 6.21 10.8 7.2C10.8 9 8.1 8.775 8.1 11.7H9.9C9.9 9.675 12.6 9.45 12.6 7.2C12.6 5.211 10.989 3.6 9 3.6Z"
        fill={theme.secondary.softBlue2}
      />
    </svg>
  );
};
